// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-83d396dc] img {\n  max-width: 100%;\n  height: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
